import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffectOnce } from "@lib-shared/hooks";
import { BusinessPage } from "core/constants";
import { useUpdatePage } from "core/hooks";
import PaymentResult from "./components/payment-result";
import Button from "components/ui/form/button";

const Failure = () => {
    const [updateTitle,] = useUpdatePage();
    const navigate = useNavigate();

    const tryAgain = (event: any) => navigate(BusinessPage.payment);

    useEffectOnce(() => updateTitle("- Payment: Failure"));

    return (
        <section className="payment-result">
            <i className={"result-icon icon-failure"}></i>

            <h1>Payment Failed</h1>

            <PaymentResult />

            <Button onClick={tryAgain} text="Try Again" className="try-again" />
        </section>
    );
}

export default Failure;
